module.exports = __webpack_public_path__ + "static/media/img4.ef5d1257.jpg";